const pageGroupDict = {
    '/requests/my-applications': ['businessman', 'potential_businessman'],
    '/my-profile': [],
    '/requests/certificates': ['kta_cert'],
    '/requests/industrial-sites': ['upi_akimat', 'manufacturing_sites', "Обработчик заявок"],
    '/requests/invest-registry': ['upi_akimat'],
    '/requests/kta': ['kta_cert'],
    '/requests/consulting': ['upi_akimat'],
    '/analytics': ['businessman', 'potential_businessman', 'upi_akimat'],
    '/analytics/city': ['upi_akimat'],
    '/analytics/msp': ['upi_akimat'],
    '/analytics/creative': ['upi_akimat'],
    '/analytics/processing': ['upi_akimat'],
    '/analytics/tourism': ['upi_akimat'],
    '/analytics/climate': ['upi_akimat'],
    '/geo/city': [],
    '/geo/creative': [],
    '/geo/manufacturers': [],
    // 'businessman'
    // 'potential_businessman'
    // 'upi_akimat'
    // 'cms_news'
    // 'manufacturing_sites'
    // 'kta_cert'
    // 'cms_education'
}

export default function checkGroupPerm(groupsMap, user, page) {
    if (user?.is_superuser === true) {
        return true
    }
    if (Object.keys(groupsMap).length === 0 || !user) {
        return false
    } else if (pageGroupDict[page]?.length === 0) {
        return true;
    } else if (page === '/admin/users') {
        return (user?.is_superuser === true || user?.is_staff === true);
    } else {
        return (user?.groups?.some(g => pageGroupDict[page]?.includes(groupsMap[g])) || user?.groups?.some(g => pageGroupDict[page]?.includes(g)))
    }
    // return user?.groups?.filter((role) => groups.indexOf(role) !== -1).length > 0;
}